const Home = () => import('Pages/Home/Home.vue')
//const Login = () => import("Pages/Auth/Login.vue");
const Logout = () => import('Pages/Auth/Logout.vue')
//const Register = () => import('Pages/Auth/Register.vue')
//const ResetPassword = () => import('Pages/Auth/ResetPassword.vue')
//const ForgotPassword = () => import('Pages/Auth/ForgotPassword.vue')
const modelSignup = () => import('Pages/Auth/ModelSignup.vue')

export default [
  /* Start Authentication Routes */
  {
    path: '/login',
    //component: Login,
    component: Home,
    name: 'login',
    meta: {
      permission: 'guest',
      fail: '/404.html'
    },
    props: {
      dialog: true,
      mode: 'login'
    }
  },
  /*{
    path: '/forgotpassword',
    component: ForgotPassword,
    name: 'forgotpassword',
    meta: {
      permission: 'guest',
      fail: '/404.html'
    }
  },*/
  /*{
    path: '/forgotpassword/:token',
    props: true,
    component: ResetPassword,
    name: 'resetpassword',
    meta: {
      permission: 'guest',
      fail: '/404.html'
    }
  },*/
  {
    path: '/forgotpassword/:token',
    //component: Login,
    component: Home,
    name: 'resetpassword',
    meta: {
      permission: 'guest',
      fail: '/404.html'
    },
    props: route => ({
      dialog: true,
      mode: 'resetpassword',
      token: route.params.token
    })
  },
  {
    path: '/logout',
    component: Logout,
    name: 'logout',
    meta: {
      permission: 'guest',
      fail: '/404.html'
    }
  },
  /*{
    path: "/register",
    component: Register,
    name: "register",
    meta: {
      permission: "guest",
      fail: "/404.html"
    }
  }*/
  {
    path: '/modelsignup',
    component: modelSignup,
    name: 'modelsignup',
    meta: {
      permission: 'guest',
      fail: '/404.html'
    }
  }
  /* End Authentication Routes */
]



// WEBPACK FOOTER //
// ./resources/js/routes/auth/index.js